import { BackendModel, BackendService } from "../../core/backend.service";
import { Pedido } from "../pedido.model";

export class AdicionalPedido extends BackendModel {

    cantidad:number;
    precioUnitario:number;
    pedido:Pedido;
    productoId:number;
    precioCosto:number;
    descripcion:string;
    proveedor:string;
    codigoProveedorPlataforma:string;
    sinCosto:boolean;

    constructor(protected backendService:BackendService, model?:AdicionalPedido){
        super(backendService,model)
        this.descripcion = "";
    }

}


// WEBPACK FOOTER //
// ./src/app/pedido/pedido-details/adicional-pedido.ts